import jQuery from 'jquery';

jQuery(function ($) {
    'use strict';

    const $header = $('.site-header');
    const $opener = $header.find('.site-header__opener');
    const $searchForm = $header.find('.search-form');
    const desktopMql = window.matchMedia('(min-width: 1025px)');
    const $menuItems = $header.find('.has-children');

    function overflowsScreen($el) {
        if ($el.closest('.site-header__navigation--simple').length > 0) {
            const $subnav = $el.find('.subnav ul').first();
            const w = $subnav.outerWidth();
            const l = $subnav.offset().left;
            return l + w > window.innerWidth - 20;
        } else {
            return false;
        }
    }

    function initNavHovers() {
        if (desktopMql.matches) {
            // Delay closing of nav items and toggle aria-expanded on hover
            $menuItems.each(function () {
                const $item = $(this);

                if (overflowsScreen($item)) {
                    $item.addClass('open-left');
                }

                $item
                    .on('mouseover', function () {
                        $item.addClass('open');
                        $item.find('a, button').attr('aria-expanded', 'true');
                    })
                    .on('mouseout', function () {
                        $item.removeClass('open');
                        $item.find('a, button').attr('aria-expanded', 'false');
                    });
            });
        } else {
            // If on mobile, remove hover events
            $menuItems.off('mouseover mouseout');
        }
    }

    initNavHovers();

    // Toggle mobile navigation
    $opener.click(function () {
        $(this).closest('.site-header').toggleClass('open');
        $(this).attr('aria-expanded', function (i, attr) {
            return attr === 'true' ? 'false' : 'true';
        });
    });

    // Hide mobile navigation if screen size changes across desktop breakpoint
    desktopMql.addEventListener('change', function () {
        $header.removeClass('open');
        initNavHovers();
    });

    // Toggle/Submit search form
    $searchForm.on('submit', function (ev) {
        if (!$(this).closest('.site-header').hasClass('open') && !$(this).hasClass('open')) {
            ev.preventDefault();
            $(this).addClass('open');
            $(this).find('input').focus();
            $(this).find('button').attr('aria-label', 'Submit search query');
        }
    });

    // Toggle subnav via button for keyboard users and for mobile nav
    $menuItems.find('button').on('click', function (e) {
        e.preventDefault();

        let $btn = $(this);
        let $listItem = $btn.closest('.has-children');
        if ($listItem.hasClass('open')) {
            $listItem.removeClass('open');
            $btn.attr('aria-expanded', 'false');
            $listItem.children('a').attr('aria-expanded', 'false');
        } else {
            $listItem.addClass('open');
            $btn.attr('aria-expanded', 'true');
            $listItem.children('a').attr('aria-expanded', 'true');
        }
    });
});
